<template>
  <a-modal
    centered
    title='设置'
    :visible='visible'
    @cancel='handleCancel'
    width="1200px"
    :footer="null"
  >
    <a-row>
      <a-col :span="12">
        <span class="cardly-title">爆品限时抢</span>
        <a-radio-group :value="channelStatus1" @change="value => onChange(value,1)">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="2">关闭</a-radio>
        </a-radio-group>
      </a-col>
    </a-row>
    <CommodityHotSaleList
      :iconId="iconId"
      :commodityType="type"
      :crossBorderDirect="crossBorderDirect"
      @onDraggableChange="onDraggableChange"
    ></CommodityHotSaleList>
    <a-row>
      <a-col :span="12">
        <span class="cardly-title">品牌专场</span>
        <a-radio-group :value="channelStatus2" @change="value => onChange(value,2)">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="2">关闭</a-radio>
        </a-radio-group>
      </a-col>
    </a-row>
    <CommodityBrandSaleList
      :iconId="iconId"
      :commodityType="type"
      :crossBorderDirect="crossBorderDirect"
      @onDraggableChange="onDraggableChange"
    ></CommodityBrandSaleList>
  </a-modal>
</template>

<script>
import CommodityBrandSaleList from '@/views/platform/component/CommodityBrandSaleList'
import CommodityHotSaleList from '@/views/platform/component/CommodityHotSaleList'

export default {
  name: 'BrandSaleDialog',
  components: {
    CommodityBrandSaleList,
    CommodityHotSaleList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String | Number,
      default: ''
    },
    iconId: {
      type: String | Number,
      default: ''
    },
    crossBorderDirect: {
      type: String | Number,
      default: ''
    },
    channelStatus1: {
      type: String | Number,
      default: 0
    },
    channelStatus2: {
      type: String | Number,
      default: 0
    }

  },
  data() {
    return {}
  },
  methods: {
    onDraggableChange(e) {
      this.$emit('onDraggableChange', e)
    },
    handleCancel(e) {
      this.$emit('cancel')
    },

    onChange(e, type) {
      this.$emit('onRadioChange', {
        status: e.target.value ? e.target.value : 2,
        channelType: type
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cardly-title {
  margin-left: 25px;
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
  font-size: 15px;
  font-weight: 500;
}
</style>